enum ExampleFeature {
  MultiFrames = 'multi-frames',
  Video = 'video',
  SplitLayer = 'split layer',
  AudioSpectrum = 'audio spectrum'
}

export default ExampleFeature;



// WEBPACK FOOTER //
// ./src/examples/ExampleFeature.ts